import { PropertyType } from '@my-models/api-model';

export default class Utility {
  public static checkIsEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  public static checkIsMobileNumber = /^\+?[1-9]\d{1,14}$/;
  public static propertyType: PropertyType[] = [
    {
      name: 'Residential',
      isSelected: false,
      serviceType: [
        {
          name: 'Rent',
          isSelected: false,
        },
        {
          name: 'Sale',
          isSelected: false,
        },
        {
          name: 'PG/Hostel',
          isSelected: false,
        },
      ],
    },
    {
      name: 'Commercial',
      isSelected: false,
      serviceType: [
        {
          name: 'Rent',
          isSelected: false,
        },
        {
          name: 'Sale',
          isSelected: false,
        },
      ],
    },
    {
      name: 'Land/Plot',
      isSelected: false,
      serviceType: [
        {
          name: 'Rent',
          isSelected: false,
        },
        {
          name: 'Sale',
          isSelected: false,
        },
      ],
    },
  ];
  public static serverErrorMsg = 'Internal server error';
  public static SIDEBAR_MENU_OBJ = [
    {
      menuName: 'Support',
      id: 1,
      children: [
        {
          menuName: 'User Support',
          routerLink: 'support',
          id: '',
        },
        {
          menuName: 'Demo View Inventory',
          routerLink: 'p/property-view/rr',
          id: 'RR-GGN-0225-0215',
        },
        {
          menuName: 'Events Share',
          routerLink: 'p/events-view',
          id: 'B7FFBB2C-25AB-46B8-B928-A69B204FDF1E',
        },
      ],
    },
    {
      menuName: 'Re-Sale',
      id: 2,
      children: [
        {
          menuName: 'Item -1111',
          routerLink: 'p/property-view/rs',
          id: 'RS-TES-1124-0040',
        },
        {
          menuName: 'Item -244',
          routerLink: 'p/property-view/rp',
          id: 'RP-TES-1124-0045',
        },
        {
          menuName: 'Item -34545',
          routerLink: 'p/property-view/cr',
          id: 'CR-TES-1124-0047',
        },
        {
          menuName: 'Item -34545',
          routerLink: 'p/property-view/cs',
          id: 'CS-TES-1124-0048',
        },
      ],
    },
    {
      menuName: 'Inventory',
      id: 3,
      children: [
        {
          menuName: 'Item -187',
          id: 107,
        },
        {
          menuName: 'Item -245',
          id: 108,
        },
        {
          menuName: 'Item -34',
          id: 109,
        },
      ],
    },
    {
      menuName: 'Insights',
      id: 4,
      children: [
        {
          menuName: 'Locality Insights',
          id: 1010,
        },
        {
          menuName: 'Rating & Reviews',
          id: 1011,
        },
        {
          menuName: 'Transaction Prices',
          id: 1012,
        },
        {
          menuName: 'Price Trends',
          id: 1013,
        },
        {
          menuName: 'Real estate market research reports',
          id: 1014,
        },
        {
          menuName: 'Policies (GST, RERA, PMAY, Budget)',
          id: 1015,
        },
        {
          menuName: 'Area Converter Tool',
          id: 1016,
        },
        {
          menuName: 'Rent Receipt Generator',
          id: 1017,
        },
      ],
    },
    {
      menuName: 'Get Help',
      id: 5,
      children: [
        {
          menuName: 'Customer Services & FAQs',
          id: 1018,
        },
      ],
    },
    {
      menuName: 'Activity',
      id: 6,
      children: [
        {
          menuName: 'Recently Searched',
          id: 1022,
        },
        {
          menuName: 'Recently Viewed',
          id: 1023,
        },
        {
          menuName: 'Shortlisted',
          id: 104,
        },
        {
          menuName: 'Contacted',
          id: 1025,
        },
      ],
    },
  ];
}
